import styles from "../admin.module.css";
import { usePaths } from "BEDROCK/paths";
import { useEffect, useState } from "react";
import { UIIconButton } from "PosterEditor/common-components/ui-icon-drawing/ui-icon-button";
import { useAccount } from "BEDROCK/account/use-account";
import { useCollectionStore } from "entity-store/collections-store/use-collection-store";
import { LinkCTAButton } from "BEDROCK/shared-components/cta-button";
import { TemplateCollection } from "PosterEditor/model/template-collection";
import { AdminBreadcrumbs, BreadcrumbItem } from "./admin-breadcrumbs";
import { TemplatePreview } from "components/common/template-preview";
import { ProjectTemplate } from "PosterEditor/model/project-template";
import { useTemplateStore } from "entity-store/template-store/use-template-store";
import { ListItem, ListItemAction } from "admin/shared-components/list-item";
import { AlertModal } from "BEDROCK/shared-components/alert-modal";

interface CollectionsAdminProps {}

export const CollectionsListAdmin = (props: CollectionsAdminProps) => {
  const { account } = useAccount();
  const paths = usePaths();

  const {
    collections,
    createCollection,
    deleteCollection,
    isLoading,
    isError,
  } = useCollectionStore();

  const loadCollection = (collection: TemplateCollection) => {
    // const project = draftProject(false, template);
    // applyTemplateToProject(template, project);
    // paths.navigateTo(paths.mapEditor + "/" + project.id);
  };

  const editCollection = (collection: TemplateCollection) => {
    paths.navigateTo(paths.collectionEditAdmin + "/" + collection.id);
  };

  const breadcrumbs: BreadcrumbItem[] = [{ label: "Collections" }];

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <span className={styles.title}>
          <AdminBreadcrumbs items={breadcrumbs} />
        </span>
        <ListControls
          onClickAddCollection={async () => {
            await createCollection.mutateAsync();
          }}
        />
        {isLoading && <p className={styles.loading}>Loading...</p>}
        {isError && <p className={styles.error}>Error loading collections</p>}
        <List
          collections={collections ?? []}
          onClick={(collection) => {
            loadCollection(collection);
          }}
          onClickDelete={async (collection) => {
            await deleteCollection.mutateAsync(collection);
          }}
          onClickEdit={editCollection}
        />
      </div>
    </div>
  );
};

interface ListControlsProps {
  onClickAddCollection: () => void;
}
const ListControls = (props: ListControlsProps) => {
  return (
    <div className={styles.listControls}>
      <div></div>
      <LinkCTAButton onClick={props.onClickAddCollection}>
        Create +
      </LinkCTAButton>
    </div>
  );
};

interface ListProps {
  collections: TemplateCollection[];
  onClick: (collection: TemplateCollection) => void;
  onClickEdit: (collection: TemplateCollection) => void;
  onClickDelete: (collection: TemplateCollection) => void;
}
const List = (props: ListProps) => {
  return (
    <div className={styles.list}>
      {props.collections.map((c) => (
        <Item
          key={c.id}
          collection={c}
          onClick={() => {
            props.onClick(c);
          }}
          onClickEdit={() => props.onClickEdit(c)}
          onClickDelete={() => props.onClickDelete(c)}
        />
      ))}
    </div>
  );
};

interface ItemProps {
  collection: TemplateCollection;
  onClick: () => void;
  onClickEdit: () => void;
  onClickDelete: () => void;
}

const Item = (props: ItemProps) => {
  const { loadTemplatesByIDs } = useTemplateStore();
  const [isShowingDeleteAlert, setIsShowingDeleteAlert] =
    useState<boolean>(false);

  const [firstTemplate, setFirstTemplate] = useState<
    ProjectTemplate | undefined
  >(undefined);

  useEffect(() => {
    const firstTemplateID = props.collection.templateIDs[0];
    if (!firstTemplateID) return;
    loadTemplatesByIDs([firstTemplateID]).then((templates) => {
      if (templates.length > 0) {
        const template = templates[0];
        setFirstTemplate(template);
      }
    });
  }, []);

  const preview = () => {
    if (!firstTemplate) return null;
    return (
      <TemplatePreview
        template={firstTemplate}
        size={{ width: 140, height: 140 }}
      />
    );
  };

  const onClickDelete = () => {
    setIsShowingDeleteAlert(true);
  };

  const actions: ListItemAction[] = [
    {
      title: "Edit",
      onClick: props.onClickEdit,
      iconName: "PENCIL",
    },
    {
      title: "Delete",
      onClick: onClickDelete,
      iconName: "BIN",
    },
  ];

  return (
    <>
      <ListItem
        preview={preview()}
        title={props.collection.name}
        description=""
        textLinkActions={actions}
      />
      <AlertModal
        title="Delete collection?"
        message="This cannot be undone. Templates belonging to this collection will not be affected."
        isShowing={isShowingDeleteAlert}
        proceedCTA="Delete"
        onDismiss={() => setIsShowingDeleteAlert(false)}
        onProceed={() => {
          props.onClickDelete();
          setIsShowingDeleteAlert(false);
        }}
      />
    </>
  );
};
